import React from "react";
import { withRouter, Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from 'react-multi-carousel';
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { TfiLocationPin } from "react-icons/tfi";
import { BsCalendarDate } from "react-icons/bs";
import Fade from 'react-reveal/Fade';
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import {Helmet} from "react-helmet";

import MapComponent from './mapComponent'
import Slider1 from "../../assets/Slider1.jpg"
import Slider3 from "../../assets/Slider3.jpg"
import Slider4 from "../../assets/Slider4.jpg"
import Slider5 from "../../assets/Slider5.jpg"
import Slider6 from "../../assets/Slider6.jpg"
import Slider8 from "../../assets/Slider8.jpg"
import Slider9 from "../../assets/Slider9.jpeg"
import Slider10 from "../../assets/Slider10.jpg"
import training from "../../assets/icon/training.png"
import workshop from "../../assets/icon/workshop.png"
import trained from "../../assets/icon/trained.png"
import pin from "../../assets/icon/pin.png"
import Chenchule from "../../assets/Chenchule.jpeg"
import Limtsula from "../../assets/Limtsula.jpeg"
import Kumrila from "../../assets/Kumrila.jpeg"
import MannoiKonyak from "../../assets/MannoiKonyak.jpg"
import top_badge from "../../assets/top_badge.png"

import 'react-multi-carousel/lib/styles.css';
import "./home.css";
import "./home.scss";
import Footer from "../../components/Footer/footer";
import "react-toastify/dist/ReactToastify.css";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    paritialVisibilityGutter: 0
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    paritialVisibilityGutter: 0
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 0
  }
};

class home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      phone: "",
      message: "",
      errors: {},

      districtsCount: 0,
      candidatesCount: 0
    };
    this.handleName = this.handleName.bind(this);
    this.handlePhone = this.handlePhone.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.sendContact = this.sendContact.bind(this);
    this.toastFunct = this.toastFunct.bind(this);
    this.successToast = this.successToast.bind(this);
    this.warnToast = this.warnToast.bind(this);
  }
  componentDidMount(){
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    this.getDistricData()
  }
  handleName(event) {
    let errors = this.state.errors;
    let name = event.target.value.length
    if (name>1) {
      errors["name"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["name"] = "Must not be empty";
      this.setState({ errors: errors});
    }
    this.setState({
      name: event.target.value,
    });
  }
  handlePhone(object) {
    if (object.target.value.length <= object.target.maxLength) {
      this.setState({ phone: object.target.value });
    }
    let errors = this.state.errors;
    var phoneLength = object.target.value.length;
    if (phoneLength === 11 || phoneLength === 10 ) {
      errors["phone"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["phone"] = "Must be 10 digits";
      this.setState({ errors: errors});
    }
  }
  handleMessage(event) {
    let errors = this.state.errors;
    let message = event.target.value.length
    if (message>14) {
      errors["message"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["message"] = "Must be at least 15 characters";
      this.setState({ errors: errors});
    }
    this.setState({ message: event.target.value });
  }
  sendContact = async () => {
    const {name, phone, message, errors} = this.state;
    let nameWarning = this.state.errors["name"];
    let phoneWarning = this.state.errors["phone"];
    let messageWarning = this.state.errors["message"];
    if(name != "" && phone != "" && message != ""){
      if(nameWarning == null && phoneWarning == null && messageWarning == null)
      {
        this.toastFunct();
        let apiUrl = "https://dihh.nielitkohima.in/admin/api/add_helpdesk.php";
        let formData = new FormData();
        formData.append("name", this.state.name);
        formData.append("phone", this.state.phone);
        formData.append("message", this.state.message);
        await axios({
          method: "post",
          url: apiUrl,
          data: formData,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.Status === "TRUE! Helpdesk Successfully Post") {
            this.successToast();
          }
          this.setState({
            name: "",
            email: "",
            message: "",
            phone: ""
          })
         
        })
        .catch(function (error) {
          console.log(error);
        });
      }
      else{
        this.warnToast();
        console.log("Form Invalid")
      }
    }
    else{
      this.warnToast();
      console.log("Form Invalid")
    }
  };
  toastFunct() {
    toast.info("Sending ..", {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }
  successToast() {
    toast.success("Inquiry submitted successfully", {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }
  warnToast() {
    toast.warn("Form Data Invalid", {
      position: "bottom-center",
      autoClose: 2700,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  getDistricData = () => {
    fetch(`https://dihh.nielitkohima.in/admin/api/training_districtWise.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let districtsCount = 0;
        let candidatesCount = 0;
        let responseArray = responseJson;

        
        responseArray.forEach(item => {
            const totalValue = parseInt(item.Total, 10); // Convert "Total" to a number
        
            if (totalValue > 0) {
                districtsCount++;
                candidatesCount += totalValue;
            }
        });

        this.setState({
          districtsCount: districtsCount,
          candidatesCount: candidatesCount
        })
      })
      .catch((error) => {
        console.error(error);
      });
  }
  render() {
    return (
      <div>
          <Helmet>
            <html lang="en" />  
            <meta charSet="utf-8" />
            <title>NIELIT Kohima - Digital Intervention of Handloom and Handicraft</title>
            <meta name="description" content="The project 'Digital Intervention of Handicraft & Handloom' was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India." />
            <link rel="canonical" href="https://nielitdihh.in/" />
          </Helmet>
          <Carousel
              autoPlay={true}
              autoPlaySpeed={3500}
              infinite={true}
              arrows={true}
              swipeable={false}
              draggable={false}
              removeArrowOnDeviceType={["mobile"]}
              responsive={responsive}
          >
              <img src={Slider1} className="slider-img"/>
              <img src={Slider9} className="slider-img"/>
              <img src={Slider3} className="slider-img"/>
              <img src={Slider4} className="slider-img"/>
              <img src={Slider5} className="slider-img"/>
              <img src={Slider6} className="slider-img"/>
              <img src={Slider8} className="slider-img"/>
              <img src={Slider10} className="slider-img"/>
          </Carousel>
          <div className="home-content-body">
            <Row>
              <Col md={7} xs={12} sm={12}>
                <p className="home_box_1_title">Digital Intervention in Handicraft and Handloom</p>
                <p className="home_box_1_para">The North Eastern States holds great potential for development in the area of handloom, and handicraft abounds in resources. The handcrafted products not only mirror the region's culture and tradition but also play a major role in employing a vast majority of artisans and craftspeople.<br/><br/>
                  Considering this importance, the Indian Government looked forward to assigning a developmental outlook to the region by undertaking meaningful interventions in each of the NE States.<br/><br/>
                  Launched on 24th September 2021, the project objective is to accelerate artisanal growth through training, support services, linkages in technology, digital market development, and the creation of repository of artisans in the state. A total of 5920 tribal youths and women practicing either handlooms or handicrafts from Nagaland will be trained through this project's facilities.</p>
                <Link to="/about">
                  <button className="requestQuote">
                    Know more
                  </button>
                </Link>
              </Col>
              <Col md={5} xs={12} sm={12}>
                <div className="home-content-body_right">
                  <img src={top_badge} className="home-content-body_right_img"/>
                  <br clear="all" />
                  <div className="home-content-body_right_inner">
                    <div>
                      <p className="home-content-body_right_inner_header">Handicraft Training</p>
                      <Row>
                        <Col md={1} xs={1} sm={1}>
                          <TfiLocationPin
                            size={22}
                          />
                        </Col>
                        <Col xs={4} sm={4} style={{marginTop: 1}}>
                          <span>Dimapur</span>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 5}}>
                        <Col md={1} xs={1} sm={1}>
                          <BsCalendarDate
                            size={20}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 2}}>
                          <span>2nd March, 2025</span>
                        </Col>
                      </Row>
                      <hr/>
                      <p className="home-content-body_right_inner_header">Weaving Training</p>
                      <Row>
                        <Col md={1} xs={1} sm={1}>
                          <TfiLocationPin
                            size={22}
                          />
                        </Col>
                        <Col xs={11} sm={11} style={{marginTop: 1}}>
                          <span>Kohima</span>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 5}}>
                        <Col md={1} xs={1} sm={1}>
                          <BsCalendarDate
                            size={20}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 2}}>
                          <span>24th Feb, 2025</span>
                        </Col>
                      </Row>
                      <hr/>
                      <p className="home-content-body_right_inner_header">Digital Literacy Training</p>
                      <Row>
                        <Col md={1} xs={1} sm={1}>
                          <TfiLocationPin
                            size={22}
                          />
                        </Col>
                        <Col xs={4} sm={4} style={{marginTop: 1}}>
                          <span>Kohima</span>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 5}}>
                        <Col md={1} xs={1} sm={1}>
                          <BsCalendarDate
                            size={20}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 2}}>
                          <span>10th Feb, 2025</span>
                        </Col>
                      </Row>
                      <hr/>
                      <p className="home-content-body_right_inner_header">Weaving Training</p>
                      <Row>
                        <Col md={1} xs={1} sm={1}>
                          <TfiLocationPin
                            size={22}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 1}}>
                          <span>Dimapur</span>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 5}}>
                        <Col md={1} xs={1} sm={1}>
                          <BsCalendarDate
                            size={20}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 2}}>
                          <span>3rd Feb, 2025</span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="home-content-body_2">
            <Fade bottom duration={800} cascade>
              <div className="home-content-body_2_inner1">
                <p className="home_box_1_title_white">Ongoing Status</p>
                <p className="home_box_1_para_white">The project "Digital Intervention of Handicraft & Handloom" was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India.</p>
                <div className="badges-div">
                  <Row>
                    <Col md={6} sm={6} xs={6}>
                      <center>
                        <img src={pin} style={{height: 65, width: 65}}/>
                        <p className="badge-txt">Across {this.state.districtsCount} Districts</p>
                      </center>
                    </Col>
                    <Col md={6} sm={6} xs={6}>
                      <center>
                        <img src={trained} style={{height: 65, width: 65}}/>
                        <p className="badge-txt">{this.state.candidatesCount} Trained Artisians</p>
                      </center>
                    </Col>
                  </Row>
                  <Row style={{marginTop: 20}}>
                    <Col md={6} sm={6} xs={6}>
                      <center>
                        <img src={training} style={{height: 65, width: 65}}/>
                        <p className="badge-txt">11 Training Categories</p>
                      </center>
                    </Col>
                    <Col md={6} sm={6} xs={6}>
                      <center>
                        <img src={workshop} style={{height: 65, width: 65}}/>
                        <p className="badge-txt">154 Trainings Held</p>
                      </center>
                    </Col>
                  </Row>
                </div>
              </div>
            </Fade>
          </div>
          <div className="home-content-body_3">
            <Fade bottom duration={800} cascade>
              <center>
                <p className="home-content-body_3_text">Testimonial</p> 
                <p className="testimonial-subTitle">What our trainees have to say about the awareness workshops & trainings being conducted</p>
                <div className="testimony_cards_pc">
                  <Row>
                    <Col md={3}>
                      <div className="page-container">
                          <BlogCard cardImage={Chenchule} cardText={"Chenchule"} backText={"The awareness workshop helped me to get a better idea about the advancing technologies and how to implement those technologies into our profession. I would like to thank NIELIT Kohima for such an initiative."}/>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="page-container">
                          <BlogCard cardImage={MannoiKonyak} cardText={"Mannoi Konyak"} backText={"Being in a remote village in Mon district, I had no idea about how to use computers and the internet but after attending the week long training on Digital Literacy, I'm happy that I gained knowledge about digitalization."}/>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="page-container">
                          <BlogCard cardImage={Kumrila} cardText={"R. Kumrila"} backText={"I'm a weaver and today here in the training learning about computers, MS Paint helped me to better visualize my designs as I can easily create new designs, modify them and finalize them quickly. This will save me a lot of time in my work."}/>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="page-container">
                          <BlogCard cardImage={Limtsula} cardText={"Limtsula"} backText={"Being an artisian myself, this training helped me to know about computers, internet, MS Word, MS Paint and other such tools. Such an initiative helps young people like me to keep up with the modern trends in this digital world. Looking forward to more training in the near future."}/>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="testimony_cards_mobile">
                  <Carousel
                    autoPlay={true}
                    autoPlaySpeed={2500}
                    infinite={true}
                    arrows={true}
                    swipeable={false}
                    draggable={false}
                    itemClass="image-item"
                    responsive={responsive}
                  >
                      <div className="page-container">
                          <BlogCard cardImage={Chenchule} cardText={"Chenchule"} backText={"The awareness workshop helped me to get a better idea about the advancing technologies and how to implement those technologies into our profession. I would like to thank NIELIT Kohima for such an initiative."}/>
                      </div>
                      <div className="page-container">
                          <BlogCard cardImage={MannoiKonyak} cardText={"Mannoi Konyak"} backText={"Being in a remote village in Mon district, I had no idea about how to use computers and the internet but after attending the week long training on Digital Literacy, I'm happy that I gained knowledge about digitalization."}/>
                      </div>
                      <div className="page-container">
                          <BlogCard cardImage={Kumrila} cardText={"R. Kumrila"} backText={"I'm a weaver and today here in the training learning about computers, MS Paint helped me to better visualize my designs as I can easily create new designs, modify them and finalize them quickly. This will save me a lot of time in my work."}/>
                      </div>
                      <div className="page-container">
                          <BlogCard cardImage={Limtsula} cardText={"Limtsula"} backText={"Being an artisian myself, this training helped me to know about computers, internet, MS Word, MS Paint and other such tools. Such an initiative helps young people like me to keep up with the modern trends in this digital world. Looking forward to more training in the near future."}/>
                      </div>
                  </Carousel>
                </div>
              </center>
            </Fade>
          </div>
          <div className="home-content-body_4">
            <Row>
              <Col md={6} xs={12} sm={12}>
                <MapComponent/>
              </Col>
              <Col md={6} xs={12} sm={12}>
                <Fade bottom duration={800} cascade>
                  <div className="home-content-body_4_inner1">
                    <p className="home_box_1_title_white">Helpdesk</p>
                    <p className="home_box_1_para_white">Fill up the form and our team will get back to you</p>
                    <div className="contact-icon-first-home">
                      <Row>
                        <Col md={1} xs={2} sm={2}>
                          <FaPhoneAlt
                            size={22}
                            className="loc-icons"
                          />
                        </Col>
                        <Col md={5} xs={10} sm={10}>
                          <a href={"tel:" + "+919436215243"}>
                            <p className="contact-div1-subtitle-home number">+91-94362-15243</p>
                          </a>
                        </Col>
                      </Row>
                    </div>
                    <div className="contact-icon-second-home">
                      <Row>
                        <Col md={1} xs={2} sm={2}>
                          <IoIosMail
                            size={28}
                            className="loc-icons"
                          />
                        </Col>
                        <Col md={4} xs={10} sm={10}>
                          <p className="contact-div1-subtitle-home number" onClick={() => window.location = 'mailto:admin@nielitkohima.in'}>admin@nielitkohima.in</p>
                        </Col>
                      </Row>
                    </div>
                    <input
                      className="in-cus-ct input_"
                      type="text"
                      placeholder="Full Name"
                      enterKeyHint="next"
                      value={this.state.name}
                      onChange={this.handleName}
                      onFocus={this.handleName}
                    />
                    {
                      this.state.errors["name"] ? (
                        <p className="loginErrorTxt">
                          {this.state.errors["name"]}
                        </p>
                      ) : (
                        <div className="emptyErrorMargins"></div>
                      )
                    }
                    <input
                      className="in-cus-ct input_"
                      placeholder="Phone Number"
                      onChange={this.handlePhone}
                      onFocus={this.handlePhone}
                      value={this.state.phone}
                      type = "number" maxLength = "10"
                    />
                    {
                      this.state.errors["phone"] ? (
                        <p className="loginErrorTxt">
                          {this.state.errors["phone"]}
                        </p>
                      ) : (
                        <div className="emptyErrorMargins"></div>
                      )
                    }
                    <textarea
                      className="in-cus-ct messageInput"
                      type="text"
                      placeholder="Message"
                      rows="4"
                      value={this.state.message}
                      onFocus={this.handleMessage}
                      onChange={this.handleMessage}
                    />
                    {
                      this.state.errors["message"] ? (
                        <p className="loginErrorTxt">
                          {this.state.errors["message"]}
                        </p>
                      ) : (
                        <div className="emptyErrorMargins_TextBox"></div>
                      )
                    }
                    <center>
                      <button className="requestQuote" onClick={this.sendContact}>
                        Submit
                      </button>
                    </center>
                    
                  </div>
                </Fade>
              </Col>
            </Row>
            <ToastContainer
              position="bottom-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
          <Footer/>
      </div>
    )
  }
}
class BlogCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { flipped: false };
    this.flip = this.flip.bind(this);
  }

  flip = () => {
    this.setState({ flipped: !this.state.flipped });
  }
  render() {
    return (
      <div onMouseEnter={this.flip} onMouseLeave={this.flip} className={"card-container" + (this.state.flipped ? " flipped" : "")}>
        <Front cardImage={this.props.cardImage} cardText={this.props.cardText}/>
        <Back backText={this.props.backText} cardText={this.props.cardText}/>
      </div>

    )
  }
}

class Front extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="front">
        <ImageArea cardImage={this.props.cardImage}/>
        <MainArea cardText={this.props.cardText}/>
      </div>
    )
  }
}

class Back extends React.Component {
  render() {
    return (
      <div className="back prod-cards-hover-back-div">
        <p className="prod-cards-hover-back"><q>{this.props.backText}</q></p>
      </div>
    )
  }
}

class ImageArea extends React.Component {
  render() {
    return (
      <div className="image-container">
        <img className="card-image" src={this.props.cardImage}></img>
      </div>
    )
  }

}

class MainArea extends React.Component {
  render() {
    return (
      <div className="main-area">
        <div className="blog-post">
          <p className="title">{this.props.cardText}</p>
        </div>
      </div>
    )
  }
}
export default withRouter(home);
